module.exports = __webpack_public_path__ + "static/2-fdf5c97fdd9628b93f7dcf3865f07e63.jpeg";